import { render, staticRenderFns } from "./PsychotechnicFileUpload.vue?vue&type=template&id=69935688&"
import script from "./PsychotechnicFileUpload.vue?vue&type=script&lang=js&"
export * from "./PsychotechnicFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports